import { useCallback } from 'react'
import { useDispatch } from 'react-redux'
// import { makeStyles } from '@material-ui/core/styles'

import EditorTextField from '../../Common/Input/EditorTextField'
import {
  updateGroupProperty,
  GROUP_PROPERTIES
} from '../../../modules/reducerGroups'

// const useStyles = makeStyles((theme) => ({
//   root: {}
// }))

const GEDescription = ({ id, description }) => {
  // const tag = useSelector(getCurrentTag)
  // const classes = useStyles()
  const dispatch = useDispatch()

  const updateTagValue = useCallback(
    (value) => {
      dispatch(updateGroupProperty(id, GROUP_PROPERTIES.DESCRIPTION, value))
    },
    [dispatch, id]
  )

  return (
    <EditorTextField
      label="Descripción"
      value={description}
      multiline
      rowsMax={4}
      onChange={updateTagValue}
    />
  )
}
export default GEDescription
